import { z } from "zod";
export const ALLOWED_ANALYSIS_MODELS = [
    "openai/openai/gpt/5.4",
    "openai/openai/gpt/5.2",
    "google/google/gemini/3.1-pro-preview",
    "anthropic/anthropic/claude/sonnet-4-6",
    "anthropic/anthropic/claude/opus-4-6",
    "cloudflare-workers-ai/alibaba/qwen/3.5-397b-a17b",
    "cloudflare-workers-ai/moonshotai/kimi/k2.6",
    "openrouter/openai/gpt/5.2",
    "openrouter/anthropic/claude/sonnet-4-6",
    "openrouter/google/gemma/4-31b-it",
    "openrouter/moonshotai/kimi/k2.6",
    "openrouter/alibaba/qwen/qwen3-32b",
];
export const analysisModelIdSchema = z.enum(ALLOWED_ANALYSIS_MODELS);
export const analysisModelPreferenceValueSchema = z.object({
    model: analysisModelIdSchema,
});
export const modelInfoSchema = z.object({
    id: analysisModelIdSchema,
    accessProvider: z.enum([
        "openai",
        "anthropic",
        "google",
        "openrouter",
        "cloudflare-workers-ai",
    ]),
    modelOwner: z.enum(["openai", "anthropic", "google", "alibaba", "moonshotai"]),
    modelFamily: z.enum(["gpt", "claude", "gemini", "gemma", "qwen", "kimi"]),
    modelVersion: z.string(),
    accessProviderModelCode: z.string(),
    responseSpec: z.enum(["openai", "anthropic", "google", "openai-compatible"]),
    displayName: z.string(),
    poweredBy: z.string(),
    contextWindow: z.number(),
    maxOutputTokens: z.number().optional(),
});
export const selectModelRequestSchema = z.object({
    modelId: analysisModelIdSchema,
});
export const getModelPreferencesResponseSchema = z.object({
    models: z.array(modelInfoSchema),
    current: analysisModelPreferenceValueSchema,
});
export const selectModelResponseSchema = z.object({
    success: z.boolean(),
    modelId: analysisModelIdSchema,
});
